import { NestedCheckboxGroup } from "components/Form/components/CheckboxGroup/CheckboxGroupFormComponent";
import { getCheckedRecordValue } from "containers/AdvancedSearch/utils";
import { useCallback } from "react";
import { Field } from "react-final-form";
import { RecordTypeListProps } from "../interfaces";

export const RecordTypeFilter = ({
    name,
    resourceList,
    resourceTypeFilter,
    onAllValuesChange,
    onChange,
    totalResourcesNumber,
    resourceArray,
}: RecordTypeListProps) => {
    const resourceValue = getCheckedRecordValue(
        resourceArray,
        totalResourcesNumber,
        resourceTypeFilter
    );

    const onAllResourcesChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            if (resourceValue) {
                onAllValuesChange(name, []);
            } else {
                onAllValuesChange(name, resourceArray);
            }
        },
        [resourceValue, onAllValuesChange, name, resourceArray]
    );

    const onResourceValueChange = (value) => (e) => onChange(name, value)(e);

    return (
        <>
            <Field name={name} id={name}>
                {({ input }) => (
                    <NestedCheckboxGroup
                        mainLabel="All"
                        mainCheckboxValue={resourceValue}
                        onChangeAll={onAllResourcesChange}
                        identifier={name}
                        input={input}
                        options={resourceList}
                        onChange={onResourceValueChange}
                    />
                )}
            </Field>
        </>
    );
};
